import { styled, Typography } from '@mui/material';

export const AuthSubheading = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(-1),
  textAlign: 'center',
})) as typeof Typography;
